import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TableHeader from './TableHeader';
import TableData from './TableData';
import MoreFieldsDropdown from 'components/common-components/MoreFieldsDropdownNew';
import FolderFilterToggler from 'components/common-components/FolderFilterToggler';
import TableFolderListFilter from 'pages/folders/TableFolderListFilter';
import { useTranslation } from 'react-i18next';
import Loader from 'components/common-components/Loader';
import { useSelector } from 'react-redux';

const TableComponent = ({
  header,
  data,
  loader,
  props,
  isFieldSelectionEnabled,
  isActionsEnabled,
  isSelectionEnabled,
  selectionKey,
  onSelection,
  selectedRows,
  selectedColumns,
  onColumnSelection,
  filteringData,
  noDataComponent,
  headerCellBorder,
  bodyCellBorder,
  noWrap,
}) => {
  let {
    type,
    updateFilteringData,
    setTableHeaderChange,
    filteringHeader,
    headerPersistKey,
    resetHeader,
    mediaEnabled,
    folderFilterOpen,
    setFolderFilterOpen,
  } = { ...props };
  const { t } = useTranslation();
  const savedHeaders = useSelector((state) => state.auth?.customizedTableHeader);

  const [tableHeaderTesting, setTableHeaderTesting] = useState([]);

  useEffect(() => {
    if (headerPersistKey && savedHeaders?.[headerPersistKey]) {
      setTableHeaderTesting(savedHeaders[headerPersistKey]);
    } else {
      setTableHeaderTesting(header);
    }
  }, [header, savedHeaders, headerPersistKey]);

  return (
    <div className='d-flex'>
      <div className='flex-grow-1 overflow-auto position-relative'>
        {isFieldSelectionEnabled && (
          <div className={`position-absolute end-0`}>
            <MoreFieldsDropdown
              fieldList={filteringHeader ? filteringHeader : tableHeaderTesting}
              setFieldListSelection={
                setTableHeaderChange ? setTableHeaderChange : setTableHeaderTesting
              }
              headerPersistKey={headerPersistKey}
              resetHeader={resetHeader}
            />
          </div>
        )}
        {type === 'form_list' && !folderFilterOpen && (
          <div className='position-absolute top-0 end-0'>
            <FolderFilterToggler onClick={() => setFolderFilterOpen(true)} />
          </div>
        )}
        <div className={`table-component-new`}>
          <table
            className={`table-custom ${
              type === 'form_permissions'
                ? 'inverse'
                : type === 'userAccessedForms'
                ? 'bordered'
                : type === 'form_version'
                ? 'version'
                : type === 'data_sources_entries'
                ? 'entries'
                : type === 'profiles_list'
                ? 'profiles'
                : type === 'data_source_filter_list'
                ? 'table-bordered'
                : type === 'submission_logs'
                ? 'text-left'
                : ''
            } `}
          >
            <TableHeader
              tableFields={tableHeaderTesting}
              onSelection={onSelection}
              mediaEnabled={mediaEnabled}
              isActionsEnabled={isActionsEnabled}
              isSelectionEnabled={isSelectionEnabled}
              selectionValue={
                selectedRows?.length > 0 ? selectedRows.length === data.length : false
              }
              type={type}
              selectedColumns={selectedColumns}
              onColumnSelection={onColumnSelection}
              cellBorder={headerCellBorder}
            />
            <TableData
              onSelection={onSelection}
              data={data}
              tableFields={tableHeaderTesting}
              props={props}
              isSelectionEnabled={isSelectionEnabled}
              isActionsEnabled={isActionsEnabled}
              selectionKey={selectionKey}
              selectedRows={selectedRows}
              cellBorder={bodyCellBorder}
              noWrap={noWrap}
            />
          </table>
          {loader && data && data.length === 0 && (
            <div className='d-flex flex-grow-1'>
              <div className='w-100 d-flex justify-content-center align-items-center'>
                <Loader color='green-1' />
              </div>
            </div>
          )}
          {!loader && data && data.length === 0 && (
            <div className='d-flex flex-grow-1'>
              {noDataComponent || (
                <span className='text-center align-self-center mx-auto'>
                  {t('text_no_records_found')}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      {type === 'form_list' && folderFilterOpen && (
        <TableFolderListFilter
          closeFilter={() => setFolderFilterOpen(false)}
          filteringData={filteringData}
          updateFilteringData={updateFilteringData}
        />
      )}
    </div>
  );
};
TableComponent.propTypes = {
  selectedRows: PropTypes.array,
  selectedColumns: PropTypes.array,
  onColumnSelection: PropTypes.func,
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  loader: PropTypes.bool.isRequired,
  props: PropTypes.object.isRequired,
  isFieldSelectionEnabled: PropTypes.bool.isRequired,
  isActionsEnabled: PropTypes.bool.isRequired,
  isSelectionEnabled: PropTypes.bool.isRequired,
  selectionKey: PropTypes.string,
  maintainTableHeight: PropTypes.bool,
  maintainTableMaxHeight: PropTypes.bool,
  onSelection: PropTypes.func,
  debounceFunc: PropTypes.func,
  filteringData: PropTypes.object,
  setFilteringData: PropTypes.func,
  noDataComponent: PropTypes.object,
  headerCellBorder: PropTypes.string,
  bodyCellBorder: PropTypes.string,
  noWrap: PropTypes.bool,
};
export default TableComponent;
